module.exports = __webpack_public_path__ + "img/annie2-min.86bc855e.png";